import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { ligas } from '../../json/ligas';

import './ligas.css';

const iconos = [
  'fa-id-card',
  'fa-clipboard-list',
  'fa-users',
  'fa-user-group',
  'fa-chart-column',
  'fa-user-tie',
  'fa-user',
  'fa-building',
  'fa-file-lines',
  'fa-circle-check',
  'fa-shield-halved',
  'fa-book-open',
  'fa-desktop',
  'fa-gavel',
];

const Ligas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="ligas-page">
      <div className="container ligas-modern-container">

        <div className="ligas-modern-heading">
          <h1>Ligas de Interés</h1>
          <span className="ligas-modern-heading-line" />
        </div>

        <div className="row ligas-modern-grid">
          {ligas.map((item, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 col-12"
            >
              <Link
                to={item.url ? item.url : ''}
                target="_blank"
                rel="noopener noreferrer"
                className="ligas-modern-link"
              >
                <article className="ligas-modern-card">

                  <div className="ligas-modern-icon">
                    <i
                      className={`fa-solid ${
                        iconos[index] || 'fa-link'
                      }`}
                    />
                  </div>

                  <div className="ligas-modern-content">
                    <h2>{item.nombre}</h2>
                  </div>

                  <div className="ligas-modern-arrow">
                    <i className="fa-solid fa-chevron-right" />
                  </div>

                </article>
              </Link>
            </div>
          ))}
        </div>

      </div>
    </main>
  );
};

export default Ligas;